<template>
  <div class="payment-result">
    <div class="pay-success text-center">
      <h2 class="pt-10 mb-5">Платеж принят</h2>

      <v-progress-linear color="success" value="100"></v-progress-linear>

      <p class="pt-10"><small>
        Вы будете перенаправлены в <a :href="targetLink">личный кабинет</a> через {{ this.timeToRedirect / 1000 }}
        секунд.
        <a :href="this.targetLink">Нажмите</a>, чтобы перейти сейчас.
      </small>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentSuccessComponent",
  data: () => ({
    targetLink: `${process.env.MY_VLADLINK}/pay?panel=autopayments`,
    timeToRedirect: 3000
  }),
  methods: {

  },
  created() {
    setTimeout(() => {window.location.href = this.targetLink}, this.timeToRedirect);
  },
}
</script>

<style scoped>
.pay-success {
  p {
    color: green;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentSuccessComponent.vue